import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import { IoMdStar } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";
import TrackingMap from "./TrackingMap";
import { FiFilter, FiDownload, FiTrash2 } from "react-icons/fi";
import { TbFilterPin } from "react-icons/tb";
import { getCursorState, getFilteredOffset } from "../utils/householdCursor";
import { matchesHouseParity } from "../utils/streetMatch";
import { canSortLocally, sortRows, getCanvassSortValue } from "../utils/sortRows";
import TagInput from "./TagInput";
import ConfigurableFilterFields from "./ConfigurableFilterFields";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import EditInputField, { EditNumberInput } from "./EditInputField";
import SearchInputField from "./SearchInputField";
import CounterSkeleton from "./CounterSkeleton";
import {
  createDatabase,
  storeDataInIndexedDB,
  fetchDataFromIndexedDB,
  updateDataInIndexedDB,
  deleteDataFromIndexedDB,
} from "../Hooks/IndexedDBUtils";
import { getStoredRole } from "../constants/roles";
import AssociatedContact from "./AssociatedContact";
import { IoIosContacts } from "react-icons/io";
import { SyncLoader } from "react-spinners";
import {
  CANVASSING_LANGUAGE_BARRIER_OPTIONS,
  IncomeSTHHOption,
} from "../constants";
import { useTheme } from "../context/ThemeContext";
import { getDispositionOptions } from "../utils/dispositionColors";
import ButtonLoader from "./ButtonLoader";
import HouseholdQuickActions from "./HouseholdQuickActions";
import MovedBadge from "./MovedBadge";
import MovedActionButton from "./MovedActionButton";
import MovedHouseholdModal from "./MovedHouseholdModal";
import useHouseholdMoved from "../Hooks/useHouseholdMoved";
import {
  buildAttemptPayload,
  buildDispositionPayload,
  saveHouseholdUpdate,
} from "../utils/householdQuickActions";
import AsyncSelect from "react-select/async";
import { getLocationRadiusCoordinates, parseDate, parseDateFromMilliseconds, showApiError } from "../utils";
import { LocationContext } from "./LocationContext";
import { BsHouseAdd } from "react-icons/bs";
import GoogleMapAutocomplete from "./Autocomplete";
import ResizablePanel from "../utils/resizablePanel";
import { fetchContactStats } from "../Hooks/useContactStats";
import {
  useOnlineStatus,
  saveHouseholdSnapshot,
  loadHouseholdSnapshot,
  clearHouseholdSnapshot,
  saveHouseholdContactsSnapshot,
  loadHouseholdContactsSnapshot,
  saveCityOptions,
  loadCityOptions as loadCachedCityOptions,
  saveDataProperties,
  loadDataProperties,
  saveUserList,
  loadUserList,
} from "../Hooks/useOfflineHousehold";
const { REACT_APP_BASE_URL } = process.env;

export const syncableTracking = createDatabase(
  "syncableTrackingDB",
  "syncableTrackingStore"
);
export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "auto",
    padding: "6px",
    // height: "700px",
    // padding: "50px 30px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "transparent",
    border: "none",
    // overflow: "auto"
  },
  overlay: {
    backgroundColor: "rgba(17, 24, 39, 0.5)",
    zIndex: "9999",
  },
};

const CanvassMap = () => {
  const mapData = useRef([]);
  const nextOffsetRef = useRef(null);
  const online = useOnlineStatus();
  const dispositionColors = useTheme()?.theme?.dispositionColors;
  const [isSavingOffline, setIsSavingOffline] = useState(false);
  const [hasOfflineSnapshot, setHasOfflineSnapshot] = useState(false);
  const [dataList, setDataList] = useState([]);
  const { movedTarget, openMoved, closeMoved, handleMoved: handleMovedBase, handleUndoMoved } =
    useHouseholdMoved(setDataList);
  const handleMoved = (householdId, newHousehold) => {
    handleMovedBase(householdId, newHousehold);
    if (newHousehold?.id && !mapData.current.some((row) => row.id === newHousehold.id)) {
      mapData.current = [...mapData.current, newHousehold];
    }
  };
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [hideLoading, setHideLoading] = useState(false);
  const [searchCity, setSearchCity] = useState("");
  const [searchCensus_block, setSearchCensus_block] = useState("");
  const [searchPresence_of_children_code, setSearchpresence_of_children_code] =
    useState("");
  const [searchStreetName, setSearchStreetName] = useState("");
  const [searchAddress, setSearchAddress] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 100;
  const [userId, setUserId] = useState("");
  const [quickBusyIds, setQuickBusyIds] = useState([]);
  // Backend strips hidden fields (property visibility, see
  // docs/implementation-plans/2026-09-15-property-visibility-survey-groups.md)
  // from a record's `properties` before it reaches the frontend - a hidden
  // field's key is simply absent here, so this tracks which fields to render.
  const [visiblePropertyKeys, setVisiblePropertyKeys] = useState(null);
  const [hiddenFields, setHiddenFields] = useState([]);
  // Same idea as hiddenFields above, but for the tenant's Contact visibility
  // settings, used by the Associated Contacts modal rather than the
  // household record itself.
  const [contactHiddenFields, setContactHiddenFields] = useState([]);
  const [mailing_city, setMailing_city] = useState("");
  const [coordinate_latitude, setCoordinate_latitude] = useState("");
  const [coordinate_longitude, setCoordinate_longitude] = useState("");
  const [mailing_address_line, setMailing_address_line] = useState("");
  const [presence_of_children_code, setPresence_of_children_code] =
    useState("");
  const [
    residence_household_gender_composition,
    setResidence_household_gender_composition,
  ] = useState("");
  const [houseHoldDisposition, setHouseHoldDisposition] = useState("");
  const [mailing_adress_zip, setMailing_adress_zip] = useState("");
  const [canvasser_email, setCanvasser_email] = useState("");
  const [residence_state, setResidence_state] = useState("");
  const [residence_zip, setResidence_zip] = useState("");
  const [house_number, setHouse_number] = useState("");
  const [building_name, setBuilding_name] = useState("");
  const [apt_number, setApt_number] = useState("");
  const token = localStorage.getItem("token");
  const userMail = localStorage.getItem("urserMail");
  const [totalAttempt, setTotalAttempts] = useState("");
  const [totalConversion, setTotalConversion] = useState("");
  const [totalRating, setTotalRating] = useState("");
  const [associatedContact, setAssociatedContact] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showAssociateList, setShowAssociateList] = useState(false);
  const [l2Id, setL2Id] = useState(null);
  const [isAssociateListLoading, setIsAssociateListLoading] = useState(false);
  const [latLngMap, setLatLngMap] = useState({});
  const [isOpenFromMap, setIsOpenFromMap] = useState(false);
  const userRole = getStoredRole();
  const cityname = localStorage.getItem("cityname");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [contactedVoters, setContactedVoters] = useState(0);
  const [isStatsLoading, setIsStatsLoading] = useState(true);
  const ownerID = localStorage.getItem("ownerId");
  const [allCityOptions, setAllCityOptions] = useState([]);
  const [listMemberData, setListMemberData] = useState([]);
  const [selectedMemberList, setSelectedMemberList] = useState("");
  const [selectedZipCode, setSelectedZipCode] = useState("");
  const [customFilterValues, setCustomFilterValues] = useState({});
  const [houseNumberParity, setHouseNumberParity] = useState("");
  const houseNumberParityOptions = [
    { label: "Odd", value: "1" },
    { label: "Even", value: "2" },
  ];
  const { locationPermission, setLocationPermission, location, setLocation } =
    useContext(LocationContext);
  const [showAddHouseHold, setShowAddHouseHold] = useState(false);
  const [houseHoldUserId, setHouseHoldUserId] = useState("");
  const [responseData, setResponseData] = useState({});
  const [showContact, setShowContact] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [formData, setFormData] = useState({
    presence_of_children_code: "",
    residence_household_gender_composition: "",
    household_disposition: "" || null,
    canvassing_language_barrier: "",
  });
  const [
    residence_families_count_of_voters_in_household,
    setResidence_families_count_of_voters_in_household,
  ] = useState("");
  const [incomesthh, setIncomeSTHH] = useState("");
  const [canvassingLanguageBarrier, setCanvassingLanguageBarrier] =
    useState("");
  const [isLoadingCoordinate, setIsLoadingCoordinates] = useState(false);
  const [selected, setSelected] = useState("");
  const [streetNumberInput, setStreetNumberInput] = useState("");
  const [buildingNameInput, setBuildingNameInput] = useState("");
  const [aptNumberInput, setAptNumberInput] = useState("");
  const [last_door_knocked_by, set_last_door_knocked_by] = useState("");
  const [last_door_knocked, set_last_door_knocked] = useState("");
  const [attempt_tracker, set_attempt_tracker] = useState("");
  const [household_attempted_, set_household_attempted_] = useState("");
  const Coordinates = getLocationRadiusCoordinates(
    location?.latitude,
    location?.longitude,
    0.25
  );
  const sortData = window.sortData;
  const [addHHResponse, setAddHHResponse] = useState({
    mailing_city: "",
    residence_state: "",
    residence_zip: "",
  });
  const [userList, setUserList] = useState([])
  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  const trackingdatabase = createDatabase("TrackingDB", "trackingStore");
  const getListMemberShipList = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_BASE_URL}/list_membership_contact`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setListMemberData(res?.data?.options);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (listMemberData?.length === 0) {
      getListMemberShipList();
    }

    return () => {
      window.canvassingFilters = "";
      window.sortData = "";
    };
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedPermission =
        JSON.parse(localStorage.getItem("isAllowLocation")) || false;
      const updatedLocation =
        JSON.parse(localStorage.getItem("currentLocation")) || {};

      setLocationPermission(updatedPermission);
      setLocation(updatedLocation);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const fatchStats = async () => {
    setIsStatsLoading(true);
    try {
      await fetchContactStats({
        token,
        setTotalAttempts,
        setTotalConversion,
        setTotalRating,
        setContactedVoters,
      });
    } finally {
      setIsStatsLoading(false);
    }
  };

  const detailHousehold = dataList.find((row) => row.id === userId);
  const detailMoved = detailHousehold?.properties?.household_moved === "true";

  const handleMovedFromDetail = () => {
    closeModal();
    openMoved(detailHousehold);
  };

  const handleUndoMovedFromDetail = () => handleUndoMoved(detailHousehold);

  const handleEditClick = (user, isOpenFromMap) => {
    openModal();
    setUserId(user?.id);
    const allKeys = Object.keys(user?.properties || {});
    setVisiblePropertyKeys(new Set(allKeys.filter((key) => !hiddenFields.includes(key))));
    setL2Id(user?.properties?.l2_household_id);
    setCanvasser_email(user?.properties?.canvasser_email || "");
    setCoordinate_latitude(
      user?.properties?.coordinate_latitude ||
      user?.properties?.latitude_numeric
    );
    setCoordinate_longitude(
      user?.properties?.coordinate_longitude ||
      user?.properties?.longitude_numeric
    );
    setMailing_address_line(user?.properties?.mailing_address_line || "");
    setMailing_adress_zip(user?.properties?.mailing_adress_zip || "");
    setMailing_city(user?.properties?.mailing_city || "");
    setPresence_of_children_code(
      user?.properties?.presence_of_children_code || ""
    );
    setResidence_household_gender_composition(
      user?.properties?.residence_household_gender_composition || ""
    );
    setResidence_state(user?.properties?.residence_state || "");
    setResidence_zip(user?.properties?.residence_zip || "");
    setHouseHoldDisposition(user?.properties?.household_disposition || "");
    setCanvassingLanguageBarrier(
      user.properties?.canvassing_language_barrier || ""
    );
    setResidence_families_count_of_voters_in_household(
      user.properties?.residence_families_count_of_voters_in_household || ""
    );
    setIncomeSTHH(user.properties?.incomesthh || "");
    set_last_door_knocked(
      parseDateFromMilliseconds(user?.properties?.last_door_knocked)
    );
    set_last_door_knocked_by(user.properties?.last_door_knocked_by || "");
    setIsOpenFromMap(isOpenFromMap);
    set_attempt_tracker(user.properties?.attempt_tracker || "");
    // Reset rather than load from the record - household_attempted_ is a one-shot Door Knock
    // trigger, not a durable stored flag, so the checkbox must always start unchecked on open
    // (also guards against a stale "true" left over from a previously opened household).
    set_household_attempted_("");
    setHouse_number(user?.properties?.house_number || "");
    setBuilding_name(user?.properties?.building_name || "");
    setApt_number(user?.properties?.apt_number || "");
  };

  const getCityOptions = async () => {
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/getCity`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        const options = response.data.cities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setAllCityOptions(options);
        saveCityOptions(options);
      }
    } catch (error) {
      console.error("Error fetching city data:", error);
    }
  };

  const surveyEntryData = async (
    customPage = null,
    key,
    isRenderMap = true
  ) => {
    setLoading(true);
    const pageNumber = customPage ? customPage : page;
    try {
      let data = {};
      if (filterPayload && key !== "RESET") {
        const filteredOffset = getFilteredOffset(pageNumber, nextOffsetRef.current, limit);
        if (userRole === "ROLE_REGIONAL_MANAGER") {
          data = {
            search_city: cityname || searchCity || null,
            offset: filteredOffset,
            limit: limit,
            ...filterPayload,
          };
        } else {
          data = {
            email: userMail,
            offset: filteredOffset,
            limit: limit,
            ...filterPayload,
          };
        }
      } else {
        if (userRole === "ROLE_REGIONAL_MANAGER") {
          data = {
            search_city: cityname,
            offset: (pageNumber - 1) * limit,
            limit: limit,
          };
        } else {
          data = {
            email: userMail,
            offset: (pageNumber - 1) * limit,
            limit: limit,
          };
        }
      }

      if (sortData !== null && !filterPayload) {
        data = {
          email: userMail,
          offset: (pageNumber - 1) * limit,
          limit: limit,
          sort_by: sortData?.sortBy,
          direction: sortData?.direction?.toUpperCase(),
        };
      }

      if (key === "RESET") {
        window.canvassingFilters = "";
        window.sortData = "";
        setDataList([]);
        deleteDataFromIndexedDB(trackingdatabase, "trackingStore");
      }
      // Add 2-second delay to prevent rate limiting
      await new Promise(resolve => setTimeout(resolve, 2000));

      await axios
        .post(
          `${REACT_APP_BASE_URL}/householdList`,
          {
            ...data,
            owner_id: ownerID,
            ...(userRole === "ROLE_REGIONAL_MANAGER" ? { role: userRole } : ""),
            ...(locationPermission && Object.keys(location).length > 0
              ? {
                current_lat_long: [location?.latitude, location?.longitude],
                min_lat: Coordinates?.minLat,
                min_long: Coordinates?.minLon,
                max_lat: Coordinates?.maxLat,
                max_long: Coordinates?.maxLon,
              }
              : {}),
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const newData = res.data.results;
          const { hasCursor, nextOffset, exhausted } = getCursorState(res.data, newData.length);
          nextOffsetRef.current = nextOffset;
          const loadedBefore = customPage ? 0 : mapData.current.length;
          setTotalRecord(hasCursor && exhausted ? loadedBefore + newData.length : res?.data?.total);
          setHiddenFields(res?.data?.hidden_fields || []);
          if (newData.length === 0) {
            setAllDataLoaded(true);
          } else {
            setAllDataLoaded(exhausted);
            setIsCheckedAll(true);
            const newArray = newData.map((data) => ({
              ...data,
              is_check: true,
            }));
            setDataList((prevData) =>
              customPage ? newArray : [...prevData, ...newArray]
            );
            // if (isRenderMap) {
            mapData.current = customPage
              ? newArray
              : [...mapData.current, ...newArray];
            // }
            if (newData.length > 0) {
              storeDataInIndexedDB(trackingdatabase, "trackingStore", newData);
            }
          }
          // Advance from the page actually fetched (pageNumber), not the stale
          // `page` state closure - using `page` here skips a large range of
          // records whenever this call used an explicit customPage (e.g. after
          // Reset) that differs from whatever `page` had already advanced to.
          setPage(pageNumber + 1);

          setHideLoading(false);
        })
        .catch(async (error) => {
          if (error.response) {
            showApiError(error, "Failed to load households");
          } else if (customPage) {
            // No response object means the request never reached the server -
            // navigator.onLine only reflects the network interface being up,
            // not real internet connectivity, so this can fire even though
            // the app still thinks it's "online". Fall back to the explicit
            // "Download" snapshot only - never trackingdatabase, which
            // auto-caches whatever was last viewed online regardless of
            // whether the user ever pressed Download.
            const snapshot = await loadHouseholdSnapshot();
            const snapshotArray = Array.isArray(snapshot) ? snapshot : [];
            setDataList(snapshotArray);
            mapData.current = snapshotArray;
            setTotalRecord(snapshotArray.length);
            setAllDataLoaded(true);
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 2000);
    }
  };

  useEffect(() => {
    setLoading(true)
    if (navigator.onLine === false) {
      // Only ever show what the user explicitly saved via "Download" -
      // trackingdatabase is a separate, pre-existing auto-cache that silently
      // stores whatever page/filter was last viewed online, regardless of
      // whether Download was ever pressed. Falling back to it here would show
      // data the user never chose to save for offline (e.g. an unfiltered
      // view browsed after downloading a filtered one).
      loadHouseholdSnapshot().then((snapshot) => {
        const snapshotArray = Array.isArray(snapshot) ? snapshot : [];
        setDataList(snapshotArray);
        mapData.current = snapshotArray;
        setTotalRecord(snapshotArray.length);
        setAllDataLoaded(true);
      });
    }
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    if (navigator.onLine === false) {
      // getCityOptions() only ever runs while online, so the city filter
      // dropdown would otherwise stay empty offline.
      loadCachedCityOptions().then((options) => {
        if (Array.isArray(options) && options.length > 0) setAllCityOptions(options);
      });
    }

    // Whether a "Download" snapshot exists is independent of current
    // connectivity - check it regardless so "Clear cached data" can be shown
    // any time there's something to clear, not only while offline.
    loadHouseholdSnapshot().then((snapshot) => {
      setHasOfflineSnapshot(Array.isArray(snapshot) && snapshot.length > 0);
    });
  }, []);

  const [showSaveContactsPrompt, setShowSaveContactsPrompt] = useState(false);
  const [isSavingContacts, setIsSavingContacts] = useState(false);

  const handleSaveOffline = async () => {
    setIsSavingOffline(true);
    try {
      await saveHouseholdSnapshot(dataList);
      setHasOfflineSnapshot(true);
      // Don't toast success here - the confirm modal opens immediately after,
      // so a toast and a modal both appearing at once is redundant and reads
      // like two separate outcomes. Whichever the user picks next (No -> just
      // household data, Yes -> household + contacts) shows one final message
      // that reflects everything actually saved.
      setShowSaveContactsPrompt(true);
    } catch (error) {
      console.error("Error saving offline snapshot:", error);
      toast.error("Failed to save offline data");
    } finally {
      setIsSavingOffline(false);
    }
  };

  const handleDeclineSaveContacts = () => {
    setShowSaveContactsPrompt(false);
    toast.success("Household data saved for offline use");
  };

  const handleSaveContactsForOffline = async () => {
    setShowSaveContactsPrompt(false);
    setIsSavingContacts(true);
    let failedCount = 0;
    // The backend proxies each of these to HubSpot, which is rate-limited to
    // 4 req/1000ms. Firing all households at once via Promise.all overruns
    // that limit and HubSpot starts returning 429s for a large saved list.
    // Fetch in small batches with a pause between them instead.
    const BATCH_SIZE = 3;
    const BATCH_DELAY_MS = 1100;
    const fetchOne = async (household) => {
      try {
        const response = await axios.post(
          `${REACT_APP_BASE_URL}/householdDatabase`,
          { householdID: household.id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        await saveHouseholdContactsSnapshot(household.id, response.data.results);
      } catch (error) {
        failedCount += 1;
        console.error(`Error caching contacts for household ${household.id}:`, error);
      }
    };
    try {
      for (let i = 0; i < dataList.length; i += BATCH_SIZE) {
        const batch = dataList.slice(i, i + BATCH_SIZE);
        await Promise.all(batch.map(fetchOne));
        if (i + BATCH_SIZE < dataList.length) {
          await new Promise((resolve) => setTimeout(resolve, BATCH_DELAY_MS));
        }
      }
      if (failedCount > 0) {
        toast.error(`Household data saved, but ${failedCount} household(s)' contacts failed to cache`);
      } else {
        toast.success("Household and associated contacts saved for offline use");
      }
    } finally {
      setIsSavingContacts(false);
    }
  };

  const handleClearCachedData = async () => {
    await clearHouseholdSnapshot();
    setHasOfflineSnapshot(false);
    toast.success("Cached data cleared");
  };

  useEffect(() => {
    if (navigator.onLine) {
      surveyEntryData(1);
      getCityOptions();
    }
  }, []);

  const loadCityOptions = async (inputValue) => {
    // AsyncSelect calls this on every keystroke; getCityOptions() already
    // fetched the full list once on mount, so filter that in-memory list
    // instead of hitting /getCity again on every change.
    if (allCityOptions.length > 0) {
      return allCityOptions.filter((city) =>
        city.label.toLowerCase().includes(inputValue.toLowerCase())
      );
    }
    if (!navigator.onLine) {
      const cached = await loadCachedCityOptions();
      return (Array.isArray(cached) ? cached : []).filter((city) =>
        city.label.toLowerCase().includes(inputValue.toLowerCase())
      );
    }
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/getCity`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        const filteredOptions = response.data.cities
          .filter((city) =>
            city.name.toLowerCase().includes(inputValue.toLowerCase())
          )
          .map((city) => ({
            value: city.name,
            label: city.name,
          }));
        return filteredOptions;
      }
    } catch (error) {
      console.error("Error fetching city data:", error);
      return [];
    }
  };

  const handlePagination = () => {
    if (!loading && !allDataLoaded) {
      surveyEntryData();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    try {
      const data = {
        id: userId,
        canvasser_email: canvasser_email || "",
        coordinate_latitude: coordinate_latitude || "",
        coordinate_longitude: coordinate_longitude || "",
        mailing_address_line: mailing_address_line || "",
        mailing_adress_zip: mailing_adress_zip || "",
        mailing_city: mailing_city || "",
        presence_of_children_code: presence_of_children_code || "",
        residence_household_gender_composition:
          residence_household_gender_composition || "",
        residence_state: residence_state || "",
        residence_zip: residence_zip || "",
        household_disposition: houseHoldDisposition || "",
        canvassing_language_barrier: canvassingLanguageBarrier || "",
        incomesthh: incomesthh || "",
        residence_families_count_of_voters_in_household:
          residence_families_count_of_voters_in_household || "",
        // Not sent here - last_door_knocked, last_door_knocked_by, household_attempted_, and
        // attempt_tracker are all owned by handleHouseholdAttempt's dedicated checkbox submit,
        // which already sends last_door_knocked/last_door_knocked_by alongside
        // household_attempted_: "true" in its own PUT. Sending them again from this general
        // field-edit save was overwriting them (household_attempted_ was always falsy in this
        // form's local state, so every plain edit cleared it back to blank on HubSpot).
        house_number: house_number || "",
        building_name: building_name || "",
        apt_number: apt_number || "",
      };
      const storedSyncableTracking = await fetchDataFromIndexedDB(
        syncableTracking,
        "syncableTrackingStore"
      );

      if (navigator.onLine === false) {
        const existingQueued = (storedSyncableTracking || []).find(
          (entry) => entry.id === data?.id
        );
        const updatedIndexData = {
          id: data?.id,
          properties: {
            ...(existingQueued?.properties || {}),
            ...data,
          },
        };
        delete updatedIndexData.properties.id;
        storeDataInIndexedDB(syncableTracking, "syncableTrackingStore", [
          ...(storedSyncableTracking || []).filter(
            (entry) => entry.id !== data?.id
          ),
          updatedIndexData,
        ]);
        // Update in-memory dataList so the map/table shows latest data immediately
        setDataList((prevData) =>
          prevData.map((item) =>
            item.id === userId ? { ...item, properties: { ...item.properties, ...updatedIndexData.properties } } : item
          )
        );
        closeModal();
        toast.success("Household offline updated successfully!");
        updateDataInIndexedDB(
          trackingdatabase,
          "trackingStore",
          data?.id,
          updatedIndexData
        );
      } else {
        const res = await axios.put(
          `${REACT_APP_BASE_URL}/householdList`,
          { ...data, owner_id: ownerID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        surveyEntryData(1, null, false);
        if (res.data) {
          toast.success("Household updated successfully!");
          closeModal();
        }
        setTimeout(() => {
          fatchStats();
        }, 1000);
      }
    } catch (error) {
      // Previously this only console.log'd - if the PUT failed (HubSpot
      // rejected a property value, auth expired, 500, etc.) the user saw
      // neither a success nor an error toast, so the save looked like it
      // silently did nothing.
      console.log("Error:", error);
      showApiError(error, "Failed to update household");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const filterOnline = async () => {
    setLoading(true);
    // setHideLoading(true);
    try {
      const data = {};
      if (searchCity?.trim()) {
        data.search_city = searchCity;
      }
      if (searchCensus_block?.trim()) {
        data.census_block = searchCensus_block;
      }
      if (searchPresence_of_children_code?.trim()) {
        data.presence_of_children_code = searchPresence_of_children_code;
      }
      if (searchAddress?.length > 0) {
        data.residence_address_line = searchAddress;
      } else if (searchStreetName?.trim()) {
        data.residence_address_line = searchStreetName;
      }
      if (houseNumberParity) {
        data.house_number_type = houseNumberParity;
      }

      setFilterPayload(data);
      // handleClearFilter();
      await new Promise(resolve => setTimeout(resolve, 2000));
      const res = await axios.post(
        `${REACT_APP_BASE_URL}/householdList`,
        {
          email: userMail,
          owner_id: ownerID,
          offset: 0,
          limit: limit,
          ...(Object.values(customFilterValues).some(Boolean) ? { custom_filters: customFilterValues } : ""),
          ...(selectedZipCode ? { residence_zip: selectedZipCode } : ""),
          ...(userRole === "ROLE_REGIONAL_MANAGER"
            ? {
              role: userRole,
              ...(!data.searchCity ? { search_city: cityname } : {}),
            }
            : {}),
          ...(selectedMemberList
            ? { list_membership: selectedMemberList }
            : ""),
          ...(houseNumberParity
            ? { house_number_type: houseNumberParity }
            : ""),
          ...(locationPermission && Object.keys(location).length > 0
            ? {
              current_lat_long: [location?.latitude, location?.longitude],
              min_lat: Coordinates?.minLat,
              min_long: Coordinates?.minLon,
              max_lat: Coordinates?.maxLat,
              max_long: Coordinates?.maxLon,
            }
            : {}),
          ...data,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // localStorage.setItem("canavassingAppFilters", JSON.stringify(data));
      window.canvassingFilters = { ...data };
      const newArray = res?.data?.results.map((data) => ({
        ...data,
        is_check: true,
      }));
      const { hasCursor, nextOffset, exhausted } = getCursorState(res.data, newArray.length);
      nextOffsetRef.current = nextOffset;
      setPage(2);
      setTotalRecord(hasCursor && exhausted ? newArray.length : res?.data?.total);
      setAllDataLoaded(exhausted);
      setHiddenFields(res?.data?.hidden_fields || []);
      setDataList(newArray);
      mapData.current = newArray;
      if (newArray.length > 0) {
        storeDataInIndexedDB(trackingdatabase, "trackingStore", newArray);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const filterOffline = () => {
    let filtered = dataList.slice();
    if (searchCity) {
      filtered = filtered.filter(
        (user) =>
          user.properties.mailing_city &&
          user.properties.mailing_city
            .toLowerCase()
            .includes(searchCity.toLowerCase())
      );
    }
    if (searchCensus_block) {
      filtered = filtered.filter(
        (user) =>
          user.properties.census_block &&
          user.properties.census_block
            .toLowerCase()
            .includes(searchCensus_block.toLowerCase())
      );
    }
    if (searchPresence_of_children_code) {
      filtered = filtered.filter(
        (user) =>
          user.properties.presence_of_children_code &&
          user.properties.presence_of_children_code
            .toLowerCase()
            .includes(searchPresence_of_children_code.toLowerCase())
      );
    }
    if (searchAddress?.length > 0) {
      filtered = filtered.filter(
        (user) =>
          user.properties.residence_address_line &&
          searchAddress.some((v) =>
            user.properties.residence_address_line
              .toLowerCase()
              .includes(String(v).toLowerCase())
          )
      );
    } else if (searchStreetName) {
      filtered = filtered.filter(
        (user) =>
          user.properties.residence_address_line &&
          user.properties.residence_address_line
            .toLowerCase()
            .includes(searchStreetName.toLowerCase())
      );
    }
    if (selectedMemberList) {
      filtered = filtered.filter(
        (user) =>
          user.properties.list_membership &&
          user.properties.list_membership === selectedMemberList
      );
    }
    if (selectedZipCode) {
      filtered = filtered.filter(
        (user) =>
          user.properties.residence_zip &&
          user.properties.residence_zip === selectedZipCode
      );
    }
    if (houseNumberParity) {
      filtered = filtered.filter((user) =>
        matchesHouseParity(user.properties, houseNumberParity)
      );
    }
    setDataList(filtered);
    mapData.current = filtered;
  };

  const manageFilter = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value.trim() !== "")
    );

    const filledCount = Object.keys(filteredData).length;

    if (filledCount > 5) {
      alert("You can select a maximum of 5 search together allowed.");
    } else {
      applyFilters();
      document.querySelector("#hs-basic-modal5").click();
    }
  };

  const applyFilters = async () => {
    if (navigator.onLine) {
      await deleteDataFromIndexedDB(trackingdatabase, "trackingStore");
      await new Promise(resolve => setTimeout(resolve, 100));
      filterOnline();
    } else {
      filterOffline();
    }
  };

  const handleCheckedItem = (index, data) => {
    dataList[index].is_check = !data.is_check;
    const unChecked = dataList.find((data) => !data.is_check);
    setIsCheckedAll(unChecked ? false : true);
    setDataList([...dataList]);
    mapData.current = [...dataList];
  };

  const handleCheckedAll = () => {
    setIsCheckedAll(!isCheckedAll);
    const newArray = dataList.map((data) => ({
      ...data,
      is_check: !isCheckedAll,
    }));
    setDataList([...newArray]);
    mapData.current = [...newArray];
  };

  useEffect(() => {
    if (navigator.onLine) {
      DatabaseProperty();
      setTimeout(() => {
        fatchStats();
      }, 1000);
    } else {
      loadDataProperties().then((properties) => {
        if (properties?.length) setDataproperty(properties);
      });
    }
  }, []);
  const showAssociateContact = async (id) => {
    if (id) {
      setIsAssociateListLoading(true);
      setShowAssociateList((prevState) => !prevState);

      if (!navigator.onLine) {
        const cachedContacts = await loadHouseholdContactsSnapshot(id);
        setAssociatedContact({ [id]: cachedContacts || [] });
        setIsAssociateListLoading(false);
        if (!cachedContacts) toast.error("Contacts not available offline for this household");
        return;
      }

      try {
        const response = await axios.post(
          `${REACT_APP_BASE_URL}/householdDatabase`,
          {
            householdID: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAssociatedContact({ [id]: response.data.results });
        setContactHiddenFields(response.data.hidden_fields || []);
        saveHouseholdContactsSnapshot(id, response.data.results);
        setIsAssociateListLoading(false);
      } catch (error) {
        console.error("Error fetching associate contact:", error);
      } finally {
        setIsAssociateListLoading(false);
      }
    }
  };

  const sortTracking = async (sortBy, direction, customPage = 0) => {
    let sortData = {
      sort_by: sortBy,
      direction: direction?.toUpperCase(),
    };

    setFilterPayload({
      ...filterPayload,
      ...sortData,
    });

    // localStorage.setItem("sortData", JSON.stringify(sortData));
    window.sortData = { ...sortData };

    if (canSortLocally(allDataLoaded, dataList)) {
      const sortedData = sortRows(dataList, (row) => getCanvassSortValue(row, sortBy), direction);
      setDataList(sortedData);
      mapData.current = sortedData;
      return;
    }

    setLoading(true);
    if (navigator.onLine) {
      try {
        let data = window.canvassingFilters !== ""
          ? {
            ...window.canvassingFilters,
            email: userMail,
            offset: 0,
            limit: limit,
            sort_by: sortBy,
            direction: direction?.toUpperCase(),
          }
          : {
            email: userMail,
            offset: 0,
            limit: limit,
            sort_by: sortBy,
            direction: direction?.toUpperCase(),
          };
        const res = await axios.post(
          `${REACT_APP_BASE_URL}/householdList`,
          {
            ...data,
            owner_id: ownerID,
            ...(locationPermission && Object.keys(location).length > 0
              ? {
                current_lat_long: [location?.latitude, location?.longitude],
                min_lat: Coordinates?.minLat,
                min_long: Coordinates?.minLon,
                max_lat: Coordinates?.maxLat,
                max_long: Coordinates?.maxLon,
              }
              : {}),
            ...(userRole === "ROLE_REGIONAL_MANAGER"
              ? {
                role: userRole,
                ...(!data.searchCity ? { search_city: searchCity } : null),
              }
              : {}),
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const newData = res.data.results;
        const { nextOffset, exhausted } = getCursorState(res.data, newData.length);
        nextOffsetRef.current = nextOffset;
        if (newData.length === 0) {
          setAllDataLoaded(true);
        } else {
          setAllDataLoaded(exhausted);
          setIsCheckedAll(true);
          const newArray = newData.map((data) => ({
            ...data,
            is_check: true,
          }));
          setTotalRecord(res?.data?.total);
          setHiddenFields(res?.data?.hidden_fields || []);
          if (newArray.length === 0) {
            setAllDataLoaded(true);
          } else {
            setDataList((prevData) =>
              customPage ? newArray : [...prevData, ...newArray]
            );
            mapData.current = customPage
              ? newArray
              : [...mapData.current, ...newArray];
          }
          setPage(2);
        }
      } catch (error) {
        if (error.response) {
          showApiError(error, "Failed to sort households");
        }
      } finally {
        setLoading(false);
        setHideLoading(false);
      }
    } else {
      const sortedData = sortRows(dataList, (row) => getCanvassSortValue(row, sortBy), direction);
      setDataList(sortedData);
      mapData.current = sortedData;
      setLoading(false);
      setHideLoading(false);
    }
  };
  const sortDatabaseCityDescending = async (customPage = null) => {
    await sortTracking("residence_city", "descending", customPage);
  };
  const sortDatabaseCityAscending = async (customPage = null) => {
    await sortTracking("residence_city", "ascending", customPage);
  };
  const sortDatabaseAddressDescending = async (customPage = null) => {
    await sortTracking("house_number", "descending", customPage);
  };
  const sortDatabaseAddressAscending = async (customPage = null) => {
    await sortTracking("house_number", "ascending", customPage);
  };
  const sortDatabaseApartmentAscending = async (customPage = null) => {
    await sortTracking("apt_number", "ascending", customPage);
  };
  const sortDatabaseApartmentDescending = async (customPage = null) => {
    await sortTracking("apt_number", "descending", customPage);
  };

  const [isCityAscending, setIsCityAscending] = useState(false);
  const [isAddressAscending, setIsAddressAscending] = useState(false);
  const [isApartmentAscending, setIsApartmentAscending] = useState(false);

  const toggleCitySortingOrder = () => {
    setIsCityAscending((prevState) => !prevState);
    setIsAddressAscending(false);
    setIsApartmentAscending(false);
  };
  const toggleAddressSortingOrder = () => {
    setIsAddressAscending((prevState) => !prevState);
    setIsCityAscending(false);
    setIsApartmentAscending(false);
  };

  const toggleApartmentSortingOrder = () => {
    setIsApartmentAscending((prevState) => !prevState);
    setIsAddressAscending(false);
    setIsCityAscending(false);
  };
  const [dataProperty, setDataproperty] = useState([]);

  const DatabaseProperty = async () => {
    let data = "";
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/databaseProperties`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data) {
        setDataproperty(response.data);
        saveDataProperties(response.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const mapRef = useRef();

  const handleRefresh = () => {
    const map = mapRef.current;
    if (map) {
      map.panTo(defaultCenter);
      map.setZoom(9);
    }
  };

  const handleClearFilter = () => {
    window.canvassingFilters = "";
    window.sortData = "";
    setSearchStreetName("");
    setSearchAddress([]);
    setSearchCity("");
    setSearchCensus_block("");
    setSearchpresence_of_children_code("");
    setSelectedZipCode("");
    setCustomFilterValues({});
    setHouseNumberParity("");
    setIsCityAscending();
    setIsAddressAscending();
    setIsApartmentAscending();
  };
  const handleReset = async () => {
    if (navigator.onLine === true) {
      await deleteDataFromIndexedDB(trackingdatabase, "trackingStore");
      setFilterPayload(null);
      nextOffsetRef.current = null;
      window.canvassingFilters = "";
      window.sortData = "";
      setSearchStreetName("");
      setSearchAddress([]);
      setSearchCity("");
      setSearchCensus_block("");
      setSearchpresence_of_children_code("");
      setSelectedZipCode("");
      setCustomFilterValues({});
      setHouseNumberParity("");
      setIsCityAscending();
      setPage(1);
      setIsAddressAscending();
      surveyEntryData(1, "RESET");

      handleRefresh();
    } else {
      // Only ever show the explicit "Download" snapshot - see the mount
      // effect above for why trackingdatabase must not be used here.
      loadHouseholdSnapshot().then((snapshot) => {
        const snapshotArray = Array.isArray(snapshot) ? snapshot : [];
        setDataList(snapshotArray);
        mapData.current = snapshotArray;
        setTotalRecord(snapshotArray.length);
        setAllDataLoaded(true);
      });
    }
  };
  const handleInputChange = async (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (
      formData?.residence_address_line !== "" &&
      formData.mailing_city !== "" &&
      formData?.residence_state !== "" &&
      formData?.residence_zip !== "" &&
      formData?.coordinate_latitude === "" &&
      formData?.coordinate_longitude === ""
    ) {
      setIsLoadingCoordinates(true);
      const address = `${formData?.residence_address_line},${formData.mailing_city}, CT, USA`;
      const res = await getLatLongFromAddress(address);
      setFormData((prev) => ({
        ...prev,
        coordinate_latitude: res.lat.toFixed(6),
        coordinate_longitude: res.lng.toFixed(6),
      }));
      setIsLoadingCoordinates(false);
    }
  };
  useEffect(() => {
    if (selected?.address_components) {
      const findComponent = (type) =>
        selected.address_components.find((comp) =>
          comp.types.includes(type)
        );

      const streetNumberComponent = findComponent("street_number");
      const buildingNameComponent = findComponent("premise");
      const aptNumberComponent = findComponent("subpremise");
      const aptNumberDigits = (aptNumberComponent?.long_name || "").replace(/\D/g, "");

      setStreetNumberInput(streetNumberComponent?.long_name || "");
      setBuildingNameInput(buildingNameComponent?.long_name || "");
      setAptNumberInput(aptNumberDigits);
    }
  }, [selected]);

  const initialLoadRef = useRef(true);
  useEffect(() => {
    // surveyEntryData(1, "RESET") wipes dataList and the trackingStore cache
    // synchronously before making its network call - if this fires while
    // offline (location updates don't require a network connection), it
    // destroys the offline fallback data with no way to recover it, leaving
    // the map/table empty until the next successful online load.
    if (location && !initialLoadRef.current && navigator.onLine) {
      surveyEntryData(1, "RESET");
    }
    initialLoadRef.current = false;
  }, [location]);

  const defaultPosition = dataList.length > 0 ? dataList[0] : null;
  var defaultCenter = Object.values(latLngMap)[0];
  if (locationPermission) {
    defaultCenter = {
      lat: location?.latitude,
      lng: location?.longitude,
    };
  } else if (defaultPosition) {
    const lat = parseFloat(defaultPosition?.properties?.latitude_numeric || defaultPosition?.properties?.aristotle_latitude);
    const lng = parseFloat(defaultPosition?.properties?.longitude_numeric || defaultPosition?.properties?.aristotle_longitude);
    if (!isNaN(lat) && !isNaN(lng)) {
      defaultCenter = { lat, lng };
    }
  }

  const handleOnLoad = (map) => {
    mapRef.current = map;
    const bounds = new window.google.maps.LatLngBounds();
    dataList.forEach((data) => {
      const position = {
        lat: parseFloat(data?.properties?.latitude_numeric || data?.properties?.aristotle_latitude),
        lng: parseFloat(data?.properties?.longitude_numeric || data?.properties?.aristotle_longitude),
      };
      bounds.extend(position);
    });
    map.fitBounds(bounds);
  };

  useEffect(() => {
    const fetchData = async () => {
      const latLngMap = {};
      const promises = dataList
        .filter((data) => data.is_check)
        .map(async (data) => {
          const address = `${data.properties.residence_address_line}, ${data.properties.mailing_city}, CT, USA`;
          const latLng = locationPermission
            ? {
              lat: data.properties.latitude_numeric || data.properties.aristotle_latitude,
              lng: data.properties.longitude_numeric || data.properties.aristotle_longitude,
            }
            : await getLatLongFromAddress(address);

          latLngMap[data.id] = latLng;
        });
      await Promise.all(promises);
      setLatLngMap(latLngMap);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    };
    fetchData();
  }, [dataList]);

  async function getLatLongFromAddress(address) {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          address
        )}&key=AIzaSyBwBtxw1WbNeANR4SlUgLHN3nuhF1qPaWs`
      );
      const location = response?.data?.results[0]?.geometry?.location;
      const latLng = { lat: location?.lat, lng: location?.lng };
      return latLng;
    } catch (error) {
      console.error("Error fetching geolocation data:", error);
      return null;
    }
  }
  const mapOptions = {
    zoom: locationPermission ? 12 : 9,
    center: defaultCenter,
    zoomControl: true,
    cameraControl: true,
    mapTypeControl: true,
    scaleControl: true,
    streetViewControl: true,
    rotateControl: true,
    fullscreenControl: false,
  };

  const formField = [
    {
      name: "presence_of_children_code",
      label: "Presence Of Children Code",
      value: formData?.presence_of_children_code,
      type: dataProperty?.find(
        (data) => data?.name === "presence_of_children_code"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "presence_of_children_code"
      )?.options,
    },
    {
      name: "residence_household_gender_composition",
      label: "Residence Household Gender Composition",
      value: formData?.residence_household_gender_composition,
      type: dataProperty?.find(
        (data) => data?.name === "residence_household_gender_composition"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "residence_household_gender_composition"
      )?.options,
    },
    {
      name: "household_disposition",
      label: "Household Disposition",
      value: formData?.household_disposition,
      type: "select",
      options: getDispositionOptions(dataProperty),
    },
    {
      name: "canvassing_language_barrier",
      label: "Canvassing Language Barrier",
      value: formData?.canvassing_language_barrier,
      type: "select",
      options: CANVASSING_LANGUAGE_BARRIER_OPTIONS,
    },
  ];

  const fetchUserList = async () => {
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/ownerlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const newData = response.data.results;
      setUserList(newData);
      saveUserList(newData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchUserList();
    } else {
      loadUserList().then((users) => {
        if (users?.length) setUserList(users);
      });
    }
  }, []);

  // Reload household data when modal opens (userId changes) to show fresh offline edits
  useEffect(() => {
    if (userId) {
      const household = dataList.find((h) => h.id === userId);
      if (household?.properties) {
        const props = household.properties;
        setMailing_address_line(props.mailing_address_line || "");
        setMailing_city(props.mailing_city || "");
        setMailing_adress_zip(props.mailing_adress_zip || "");
        setCoordinate_latitude(props.coordinate_latitude || props.latitude_numeric || "");
        setCoordinate_longitude(props.coordinate_longitude || props.longitude_numeric || "");
        setCanvasser_email(props.canvasser_email || "");
        setPresence_of_children_code(props.presence_of_children_code || "");
        setResidence_household_gender_composition(props.residence_household_gender_composition || "");
        setHouseHoldDisposition(props.household_disposition || "");
        setResidence_state(props.residence_state || "");
        setResidence_zip(props.residence_zip || "");
        setHouse_number(props.house_number || "");
        setBuilding_name(props.building_name || "");
        setApt_number(props.apt_number || "");
      }
    }
  }, [userId, dataList]);

  const handleCloseModal = () => {
    setShowAddHouseHold(false);
    setFormData(null);
    setL2Id(null);
    setResponseData(null);
    setHouseHoldUserId(null);
    setSelected("");
    setStreetNumberInput("");
    setBuildingNameInput("");
    setAptNumberInput("");
  };
  const handleHouseHoldSubmit = async (e) => {
    e.preventDefault();
    const address = selected?.address_components;
    const getAddressComponent = (type) => {
      const component = address?.find((comp) => comp.types.includes(type));
      return component ? component.long_name : "";
    };

    const lat = selected?.geometry?.location?.lat();
    const lng = selected?.geometry?.location?.lng();
    if (typeof lat !== "number" || typeof lng !== "number") {
      toast.error("Please select an address from the suggestions before saving.");
      return;
    }
    const streetNumber = streetNumberInput || getAddressComponent("street_number");
    const route = getAddressComponent("route");
    const neighborhood = getAddressComponent("sublocality_level_1");
    const locality = getAddressComponent("locality");
    const administrativeAreaLevel1 = getAddressComponent(
      "administrative_area_level_1"
    );
    const postalCode = getAddressComponent("postal_code");

    if (!streetNumber || !route) {
      toast.error("Please provide a complete street address before saving.");
      return;
    }
    if (!locality || !administrativeAreaLevel1 || !postalCode) {
      toast.error("Please select an address with city, state, and zip code.");
      return;
    }

    setAddHHResponse({
      mailing_city: locality,
      residence_state: administrativeAreaLevel1,
      residence_zip: postalCode,
    });
    let payload = {
      canvasser_email: userMail,
      canvasser_owner: ownerID,
      longitude_numeric: lng.toFixed(6),
      latitude_numeric: lat.toFixed(6),
      coordinate_latitude: lat.toFixed(6),
      coordinate_longitude: lng.toFixed(6),
      mailing_address_line: streetNumber + " " + route + " " + neighborhood,
      mailing_adress_zip: postalCode,
      mailing_city: locality,
      mailing_address_state: administrativeAreaLevel1,
      presence_of_children_code: formData?.presence_of_children_code,
      residence_household_gender_composition:
        formData?.residence_household_gender_composition,
      residence_address_line: streetNumber + " " + route + " " + neighborhood,
      residence_city: locality,
      residence_state: administrativeAreaLevel1,
      residence_zip: postalCode,
      house_number: streetNumber || "",
      building_name: buildingNameInput || "",
      apt_number: aptNumberInput || "",
      canvassing_language_barrier: formData?.canvassing_language_barrier,
      residence_families_count_of_voters_in_household:
        formData?.residence_families_count_of_voters_in_household,
      incomesthh: formData?.incomesthh,
    };
    if (houseHoldUserId) {
      try {
        const res = await axios.put(
          `${REACT_APP_BASE_URL}/householdList`,
          {
            id: houseHoldUserId,
            ...payload,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Household Update Successfully", res.data.message);
      } catch (error) {
        showApiError(error, "Failed to update household");
      }
    } else {
      try {
        const res = await axios.post(
          `${REACT_APP_BASE_URL}/add_household`,
          {
            properties: payload,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res.status === 200) {
          setResponseData(res?.data?.properties);
          setHouseHoldUserId(res?.data?.properties?.hs_object_id);
          setL2Id(res?.data?.properties?.l2_household_id);
          toast.success("Household Added Successfully");
        }
      } catch (error) {
        showApiError(error, "Failed to add household");
      }
    }
  };

  const handleHouseholdAttempt = async (e) => {
    set_household_attempted_(e.target.checked === true ? "true" : "false")
    if (e.target.checked !== true) return;
    if (!userId) return;

    const data = {
      id: userId,
      owner_id: ownerID,
      household_attempted_: "true",
      ...(last_door_knocked
        ? {
          last_door_knocked: parseDate(last_door_knocked),
        }
        : {
          last_door_knocked: parseDate(new Date().toISOString()),
        }
      ),
      last_door_knocked_by: ownerID || last_door_knocked_by,
    };

    try {
      if (navigator.onLine === false) {
        // Previously this always attempted a live PUT with no offline path,
        // unlike handleSubmit's full edit - queue it the same way so an
        // attempt marked offline isn't silently lost/failed.
        const storedSyncableTracking = await fetchDataFromIndexedDB(syncableTracking, "syncableTrackingStore");
        const existingQueued = (storedSyncableTracking || []).find(
          (entry) => entry.id === data.id
        );
        const updatedIndexData = {
          id: data.id,
          properties: { ...(existingQueued?.properties || {}), ...data },
        };
        delete updatedIndexData.properties.id;
        storeDataInIndexedDB(syncableTracking, "syncableTrackingStore", [
          ...(storedSyncableTracking || []).filter((entry) => entry.id !== data.id),
          updatedIndexData,
        ]);
        updateDataInIndexedDB(trackingdatabase, "trackingStore", data.id, updatedIndexData);
        toast.success("Household attempt saved offline!");
      } else {
        const res = await axios.put(`${REACT_APP_BASE_URL}/householdList`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Household attempted!");
      }
    } catch (error) {
      console.log(error)
      showApiError(error, "Failed to update household attempt");
    }
  }

  const runQuickAction = async (household, data, successMessage, offlineMessage, errorMessage) => {
    if (quickBusyIds.includes(household.id)) return;
    setQuickBusyIds((ids) => [...ids, household.id]);
    try {
      const { offline } = await saveHouseholdUpdate(data, { token, syncableDb: syncableTracking, trackingDb: trackingdatabase });
      const { id, owner_id, household_attempted_, ...changed } = data;
      setDataList((prevData) =>
        prevData.map((item) =>
          item.id === household.id ? { ...item, properties: { ...item.properties, ...changed } } : item
        )
      );
      toast.success(offline ? offlineMessage : successMessage);
    } catch (error) {
      showApiError(error, errorMessage);
    } finally {
      setQuickBusyIds((ids) => ids.filter((id) => id !== household.id));
    }
  };

  const handleQuickDisposition = (household, disposition) =>
    runQuickAction(
      household,
      buildDispositionPayload({ id: household.id, ownerId: ownerID, disposition }),
      "Disposition updated!",
      "Disposition saved offline!",
      "Failed to update disposition"
    );

  const handleQuickAttempt = (household) =>
    runQuickAction(
      household,
      buildAttemptPayload({
        id: household.id,
        ownerId: ownerID,
        lastDoorKnockedBy: household.properties?.last_door_knocked_by,
      }),
      "Household attempted!",
      "Household attempt saved offline!",
      "Failed to update household attempt"
    );

  return (
    <div className="bg-canvas-userbar w-full py-8 flex flex-col gap-3">
      <div className="bg-canvas-white md:p-8 p-3 flex flex-col md:gap-3 gap-8 mx-5 rounded">
        <div className="flex items-center justify-between gap-3 sm:gap-5 flex-wrap">
          <h1>Tracking</h1>
          <div className="flex gap-2 xs:gap-3 sm:gap-5 items-center flex-wrap justify-end">
            <button
              className="bg-canvas-secondery bg-opacity-30 md:w-12 w-8 md:h-12 h-8 rounded-full flex justify-center items-center shrink-0"
              onClick={() => setShowAddHouseHold(true)}
            >
              <BsHouseAdd className="md:text-2xl text-lg" />
            </button>

            <button
              className="bg-canvas-secondery bg-opacity-30 md:w-12 w-8 md:h-12 h-8 rounded-full flex justify-center items-center shrink-0"
              type="button"
              data-hs-overlay="#hs-basic-modal5"
            // onClick={handleClearFilter}
            >
              <FiFilter className="md:text-2xl text-lg" />
            </button>
            <button
              className="bg-canvas-secondery bg-opacity-30 md:w-12 w-8 md:h-12 h-8 rounded-full flex justify-center items-center shrink-0"
              type="button"
              data-hs-overlay="#hs-search-address-modal"
              title="Multi-Street Search"
            >
              <TbFilterPin className="md:text-2xl text-lg" />
            </button>
            <button
              className="p-1.5 sm:p-2 text-xs sm:text-sm font-semibold font-outfit bg-canvas-secondery bg-opacity-30 rounded whitespace-nowrap shrink-0"
              onClick={handleReset}
            >
              Reset
            </button>
            {online && dataList.length > 0 && (
              <button
                type="button"
                className="py-1.5 px-2 sm:py-2 sm:px-3 inline-flex items-center gap-x-1.5 sm:gap-x-2 text-xs sm:text-sm font-semibold font-outfit rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white disabled:cursor-progress disabled:opacity-70 whitespace-nowrap shrink-0"
                onClick={handleSaveOffline}
                disabled={isSavingOffline || isSavingContacts}
              >
                {isSavingOffline || isSavingContacts ? (
                  <ButtonLoader />
                ) : (
                  <FiDownload className="w-4 h-4 shrink-0" />
                )}
                <span className="hidden xs:inline">
                  {isSavingOffline || isSavingContacts ? "Downloading..." : "Download"}
                </span>
              </button>
            )}
            {hasOfflineSnapshot && !isSavingOffline && !isSavingContacts && !showSaveContactsPrompt && online && (
              <button
                type="button"
                className="py-1.5 px-2 sm:py-2 sm:px-3 inline-flex items-center gap-x-1.5 sm:gap-x-2 text-xs sm:text-sm font-semibold font-outfit rounded-lg border border-gray-200 bg-canvas-danger text-canvas-white whitespace-nowrap shrink-0"
                onClick={handleClearCachedData}
              >
                <FiTrash2 className="w-4 h-4 shrink-0" />
                <span className="hidden xs:inline">Clear Cache</span>
              </button>
            )}
          </div>
        </div>
        <div className="flex items-center justify-between md:justify-normal gap-6 lg:gap-16 flex-wrap">
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Attempts</h3>
            {isStatsLoading ? <CounterSkeleton /> : <h3 className="font-normal">{totalAttempt || 0}</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">
              Contacted Rate
            </h3>
            {isStatsLoading ? <CounterSkeleton /> : <h3 className="font-normal">{contactedVoters || 0} %</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Locations</h3>
            <h3 className="font-normal">
              {dataList?.filter((data) => data.is_check)?.length}
            </h3>
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">
              Conversion Rate
            </h3>
            {isStatsLoading ? <CounterSkeleton /> : <h3 className="font-normal">{totalConversion || 0} %</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Rating</h3>
            {isStatsLoading ? (
              <CounterSkeleton />
            ) : (
              <h3 className="font-normal flex gap-1 items-center">
                {totalRating || 0} <IoMdStar />
              </h3>
            )}
          </div>
        </div>
      </div>
      <div className="px-5">
        <ResizablePanel
          leftSide={
            <div className="p-1 m-1 h-full">
              {!showAddHouseHold && (
                online ? (
                  <TrackingMap
                    mapOptions={mapOptions}
                    handleOnLoad={handleOnLoad}
                    defaultCenter={defaultCenter}
                    dataList={mapData.current}
                    latLngMap={latLngMap}
                    handleEditClick={(data) => handleEditClick(data, true)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-canvas-secondery text-sm text-center p-5">
                    Map is unavailable offline. Reconnect to the internet to view the map.
                  </div>
                )
              )}
            </div>
          }
          rightSide={
            <div className="p-1 m-2 h-full flex flex-col">
              <div className="w-full bg-canvas-white flex-1 min-h-0 overflow-y-auto themed-scrollbar">
                <div className="overflow-x-auto custom-scroll-box themed-scrollbar">
                  <div className="p-1.5 min-w-full inline-block align-middle">
                    <div className="overflow-hidden">
                      <table className="min-w-full divide-y divide-canvas-primary">
                        <thead className="border-b-2">
                          <tr>
                            <th
                              scope="col"
                              className="px-2 md:py-3 py-5 text-start text-xs text-canvas-secondery font-outfit font-bold flex gap-2 "
                            >
                              <input
                                type="checkbox"
                                className="tableCheckbox"
                                checked={isCheckedAll}
                                onClick={handleCheckedAll}
                              />
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-2 py-2 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              <div className="flex gap-1 justify-center items-center">
                                <p> Apt.No. </p>
                                <button onClick={toggleApartmentSortingOrder}>
                                  {isApartmentAscending ? (
                                    <button
                                      onClick={sortDatabaseApartmentDescending}
                                    >
                                      <FaChevronUp className="h-4 w-4" />
                                    </button>
                                  ) : (
                                    <button
                                      onClick={sortDatabaseApartmentAscending}
                                    >
                                      <FaChevronDown className="h-4 w-4" />
                                    </button>
                                  )}
                                </button>
                              </div>
                            </th>

                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              <div className="flex gap-1 justify-center items-center">
                                <p> Address </p>
                                <button onClick={toggleAddressSortingOrder}>
                                  {isAddressAscending ? (
                                    <button
                                      onClick={sortDatabaseAddressDescending}
                                    >
                                      <FaChevronUp className="h-4 w-4" />
                                    </button>
                                  ) : (
                                    <button
                                      onClick={sortDatabaseAddressAscending}
                                    >
                                      <FaChevronDown className="h-4 w-4" />
                                    </button>
                                  )}
                                </button>
                              </div>
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              Attempted
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              View
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              Associated Contacts
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              Household Disposition
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              <div className="flex gap-1 items-center">
                                <p> City </p>
                                <button onClick={toggleCitySortingOrder}>
                                  {isCityAscending ? (
                                    <button
                                      onClick={sortDatabaseCityDescending}
                                    >
                                      <FaChevronUp className="h-4 w-4" />
                                    </button>
                                  ) : (
                                    <button onClick={sortDatabaseCityAscending}>
                                      <FaChevronDown className="h-4 w-4" />
                                    </button>
                                  )}
                                </button>
                              </div>
                            </th>
                            <th
                              scope="col"
                              className="md:px-6 px-3 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                            >
                              Map
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-canvas-primary/20">
                          {loading ? (
                            <tr
                              className="hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all text-center"
                            >
                              <td colSpan={9}>
                                <div className="text-center flex justify-center items-center h-[50px]">
                                  <SyncLoader color="#43524f" size={5} />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            dataList?.map((ele, i) => (
                              <tr
                                className="hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all"
                                key={ele.id}
                              >
                                <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200 text-center">
                                  <input
                                    type="checkbox"
                                    checked={ele?.is_check}
                                    className="tableCheckbox"
                                    onClick={() => handleCheckedItem(i, ele)}
                                  />
                                </td>
                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center transition-all">
                                  {ele?.properties?.apt_number || "--"}
                                </td>
                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center transition-all">
                                  {ele?.properties?.residence_address_line ||
                                    ele?.properties?.aristotle_address ||
                                    "--"}
                                  {ele?.properties?.household_moved === "true" && (
                                    <MovedBadge className="ml-2" />
                                  )}
                                </td>
                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                                  <HouseholdQuickActions
                                    showDisposition={false}
                                    busy={quickBusyIds.includes(ele.id)}
                                    onAttempt={() => handleQuickAttempt(ele)}
                                  />
                                </td>
                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleEditClick(ele, false)
                                    }
                                    data-hs-overlay="#hs-basic-modal3"
                                    className="md:py-3 py-1 md:px-4 px-2 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-canvas-primary text-white hover:scale-95 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                                  >
                                    View & Edit
                                  </button>
                                </td>

                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                                  <div className="hs-dropdown relative inline-flex">
                                    <button
                                      id="hs-dropdown-hover-event"
                                      className="hs-dropdown-toggle"
                                      onClick={() =>
                                        showAssociateContact(ele?.id)
                                      }
                                    >
                                      <IoIosContacts className="w-7 h-7" />
                                    </button>
                                    <AssociatedContact
                                      fetchStats={fatchStats}
                                      dataProperty={dataProperty}
                                      isAssociateListLoading={
                                        isAssociateListLoading
                                      }
                                      noAddContact
                                      setShowAssociateList={
                                        setShowAssociateList
                                      }
                                      showAssociateContact={
                                        showAssociateContact
                                      }
                                      associatedContact={
                                        associatedContact[ele.id]
                                      }
                                      hiddenFields={contactHiddenFields}
                                    />
                                  </div>
                                </td>

                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                                  <HouseholdQuickActions
                                    disposition={ele?.properties?.household_disposition}
                                    options={getDispositionOptions(dataProperty)}
                                    dispositionColors={dispositionColors}
                                    showDisposition={!visiblePropertyKeys || visiblePropertyKeys.has("household_disposition")}
                                    showAttempt={false}
                                    busy={quickBusyIds.includes(ele.id)}
                                    onDispositionChange={(value) => handleQuickDisposition(ele, value)}
                                  />
                                </td>
                                <td className="md:px-6 px-3 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center transition-all">
                                  {ele?.properties?.residence_city ||
                                    ele?.properties?.aristotle_city}
                                </td>
                                <td className="md:px-6 px-3 py-2 whitespace-nowrap transition-all text-xs font-outfit underline text-center">
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={`https://maps.google.com/?q=${ele?.properties?.residence_address_line || ele?.properties?.aristotle_address}, ${ele?.properties?.mailing_city}, CT, USA `}
                                  >
                                    {ele?.properties?.residence_address_line ||
                                      ele?.properties?.aristotle_address}{" "}
                                    {ele?.properties.city}{" "}
                                    {ele?.properties?.mailing_city}
                                  </a>
                                </td>
                              </tr>
                            ))
                          )}
                          {
                            !loading && dataList?.length === 0 && allDataLoaded && (
                              <tr className="text-center hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all"><td colSpan={9} className="px-6 py-4"> Data Not Found</td></tr>
                            )
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex items-center justify-center p-5 flex-shrink-0 bg-canvas-white border-t border-gray-200">
                {!allDataLoaded &&
                  !hideLoading && !loading &&
                  dataList.length > 10 &&
                  totalRecord !== dataList?.length && (
                    <button
                      type="button"
                      className="py-2 px-3 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white disabled:cursor-progress"
                      onClick={handlePagination}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  )}
              </div>
            </div>
          }
        />
      </div>
      {/* HouseHold Form */}
      {userId && (
        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          className="relative z-50"
        >
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-canvas-primary/60 backdrop-blur-sm">
            <div
              className="absolute top-0 left-0 w-full h-screen z-10"
              onClick={closeModal}
            />
            <div className="xl:max-w-6xl lg:max-w-5xl md:max-w-4xl max-w-4xl sm:w-full sm:mx-auto bg bg-white border rounded-xl pointer-events-auto max-h-[calc(100vh-3.5rem)] overflow-y-auto z-[99]">
              <div className="p-4 sm:p-6 md:p-8">
                <h2 className="font-bold uppercase flex justify-center items-center gap-3 mb-4">
                  Household Details
                  {detailMoved && <MovedBadge />}
                </h2>

                {/* {isOpenFromMap && ( */}
                <div className="mt-8  mb-10 flex justify-end items-center gap-5">
                  <MovedActionButton
                    moved={detailMoved}
                    disabled={navigator.onLine === false}
                    onClick={detailMoved ? handleUndoMovedFromDetail : handleMovedFromDetail}
                  />
                  <div className="hs-dropdown relative inline-flex ">
                    <button
                      id="hs-dropdown-hover-event"
                      className="hs-dropdown-toggle font-semibold flex items-center gap-5"
                      onClick={() => showAssociateContact(userId)}
                    >
                      ASSOCIATED CONTACTS <IoIosContacts className="w-7 h-7" />
                    </button>
                    <AssociatedContact
                      isModel
                      fetchStats={fatchStats}
                      dataProperty={dataProperty}
                      isAssociateListLoading={isAssociateListLoading}
                      setShowAssociateList={setShowAssociateList}
                      showAssociateContact={showAssociateContact}
                      associatedContact={associatedContact[userId]}
                      hiddenFields={contactHiddenFields}
                      addContactModalData={{
                        l2Id,
                        mailing_city,
                        residence_state,
                        residence_zip,
                      }}
                    />
                  </div>
                </div>
                {/* )} */}
                <form onSubmit={handleSubmit} noValidate>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("coordinate_latitude")) && (
                      <EditInputField
                        label="Coordinate Latitude"
                        name="coordinate_latitude"
                        value={coordinate_latitude}
                        onChange={(e) => setCoordinate_latitude(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("coordinate_longitude")) && (
                      <EditInputField
                        label="Coordinate Longitude"
                        name="coordinate_longitude"
                        value={coordinate_longitude}
                        onChange={(e) => setCoordinate_longitude(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("mailing_address_line")) && (
                      <EditInputField
                        label="Mailing Address Line"
                        name="mailing_address_line"
                        value={mailing_address_line}
                        onChange={(e) => setMailing_address_line(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("house_number")) && (
                      <EditInputField
                        label="Street Number"
                        name="house_number"
                        value={house_number}
                        onChange={(e) => setHouse_number(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("building_name")) && (
                      <EditInputField
                        label="Building Name"
                        name="building_name"
                        value={building_name}
                        onChange={(e) => setBuilding_name(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("apt_number")) && (
                      <EditInputField
                        label="Apt Number"
                        name="apt_number"
                        value={apt_number}
                        onChange={(e) => setApt_number(e.target.value.replace(/\D/g, ""))}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("mailing_adress_zip")) && (
                      <EditInputField
                        label=" Mailing Adress Zip"
                        name="mailing_adress_zip"
                        value={mailing_adress_zip}
                        onChange={(e) => setMailing_adress_zip(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("mailing_city")) && (
                      <EditInputField
                        label=" Mailing City"
                        name="mailing_city"
                        value={mailing_city}
                        onChange={(e) => setMailing_city(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("presence_of_children_code")) && (
                      <EditInputField
                        label="Presence Of Children Code"
                        name="presence_of_children_code"
                        value={presence_of_children_code}
                        onChange={(e) =>
                          setPresence_of_children_code(e.target.value)
                        }
                        type={
                          dataProperty?.find(
                            (data) => data?.name === "presence_of_children_code"
                          )?.fieldType
                        }
                        options={
                          dataProperty?.find(
                            (data) => data?.name === "presence_of_children_code"
                          )?.options
                        }
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("residence_household_gender_composition")) && (
                      <EditInputField
                        label="Residence Household Gender Composition"
                        name="residence_household_gender_composition"
                        value={residence_household_gender_composition}
                        onChange={(e) =>
                          setResidence_household_gender_composition(
                            e.target.value
                          )
                        }
                        type={
                          dataProperty?.find(
                            (data) =>
                              data?.name ===
                              "residence_household_gender_composition"
                          )?.fieldType
                        }
                        options={
                          dataProperty?.find(
                            (data) =>
                              data?.name ===
                              "residence_household_gender_composition"
                          )?.options
                        }
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("residence_state")) && (
                      <EditInputField
                        label="Residence State"
                        name="residence_state"
                        value={residence_state}
                        onChange={(e) => setResidence_state(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("residence_zip")) && (
                      <EditInputField
                        label="  Residence Zip"
                        name="residence_zip"
                        value={residence_zip}
                        onChange={(e) => setResidence_zip(e.target.value)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("household_disposition")) && (
                      <EditInputField
                        label="Household Disposition"
                        name="houseHoldDisposition"
                        value={houseHoldDisposition}
                        onChange={(e) => setHouseHoldDisposition(e.target.value)}
                        type="select"
                        options={getDispositionOptions(dataProperty)}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("canvassing_language_barrier")) && (
                      <EditInputField
                        label="Canvassing Language Barrier"
                        name="canvassing_language_barrier"
                        value={canvassingLanguageBarrier}
                        onChange={(e) =>
                          setCanvassingLanguageBarrier(e.target.value)
                        }
                        type="select"
                        options={CANVASSING_LANGUAGE_BARRIER_OPTIONS}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("residence_families_count_of_voters_in_household")) && (
                      <EditNumberInput
                        label="Number of Registered Voters"
                        name="residence_families_count_of_voters_in_household"
                        value={residence_families_count_of_voters_in_household}
                        onChange={(val) =>
                          setResidence_families_count_of_voters_in_household(val)
                        }
                        type="number"
                        max={12}
                        min={1}
                      />
                    )}
                    {(!visiblePropertyKeys || visiblePropertyKeys.has("incomesthh")) && (
                      <EditInputField
                        label="Household Income"
                        name="incomesthh"
                        value={incomesthh}
                        onChange={(e) => setIncomeSTHH(e.target.value)}
                        type={"select"}
                        options={IncomeSTHHOption}
                      />
                    )}
                    <EditInputField
                      label="Last Door Knocked by"
                      name="last_door_knocked_by"
                      value={last_door_knocked_by}
                      type={
                        'select'
                      }
                      options={userList?.map((item) => ({
                        value: item.id,
                        label: `${item.firstName} ${item.lastName}`
                      }))}
                      disabled={true}
                    />
                    <EditInputField
                      label="Last Door Knocked Date"
                      name="last_door_knocked"
                      value={last_door_knocked}
                      type={"date"}
                      disabled={true}
                    />
                    <EditInputField
                      label="Attempt Tracker"
                      name="attempt_tracker"
                      value={attempt_tracker}
                      disabled={true}
                    />
                    <EditInputField
                      label="Household Attempted"
                      name="household_attempted_"
                      value={household_attempted_}
                      onChange={(e) => handleHouseholdAttempt(e)}
                      type="checkbox"
                    />
                  </div>
                  <div className="flex items-center gap-5 mt-5">
                    <button
                      type="submit"
                      disabled={isSubmitLoading}
                      className="shadow bg-canvas-primary text-white font-bold py-2 px-6 rounded flex items-center gap-3"
                    >
                      {isSubmitLoading && <ButtonLoader />}
                      Save
                    </button>
                    <button
                      className="bg-gray-200 py-2 px-6 rounded"
                      onClick={(e) => closeModal(e)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Dialog>
      )}
      {/* HouseHold Search */}
      <div
        id="hs-basic-modal5"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-xl sm:w-full m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto">
            <div className="p-4 overflow-y-auto">
              <h2 className="flex justify-center">Search Field</h2>
              <h4 className="pb-5 flex justify-center text-gray-500">
                Max. 5 search together allowed.
              </h4>
              <form className="w-full " onSubmit={(e) => manageFilter(e)}>
                <ConfigurableFilterFields
                  page="canvass_map"
                  dataProperty={dataProperty}
                  bindings={{
                    residence_zip: [selectedZipCode, setSelectedZipCode],
                    census_block: [searchCensus_block, setSearchCensus_block],
                    presence_of_children_code: [searchPresence_of_children_code, setSearchpresence_of_children_code],
                  }}
                  renderers={{
                    residence_city: () => (
                      <div className="md:flex md:items-center mb-6">
                        <div className="md:w-1/3">
                          <label
                            className="block text-gray-500 font-bold text-center mb-1 md:mb-0 pr-4"
                            htmlFor="input-field"
                          >
                            City
                          </label>
                        </div>
                        <div className="md:w-2/3">
                          <AsyncSelect
                            loadOptions={loadCityOptions}
                            id="city"
                            name="city"
                            className="bg-gray-200 appearance-none border-none border-gray-200 rounded w-full  text-gray-700 leading-tight focus:outline-none z-[9999]"
                            classNames={{
                              menuList: () => "h-40",
                            }}
                            defaultOptions={allCityOptions}
                            value={
                              searchCity
                                ? allCityOptions.find(
                                  (option) => option.value === searchCity
                                )
                                : null
                            }
                            onChange={(selectedOption) => {
                              setSearchCity(
                                selectedOption ? selectedOption.value : ""
                              );
                            }}
                            isClearable
                          />
                        </div>
                      </div>
                    ),
                    street_name: () => (
                      <SearchInputField
                        label="Street Name"
                        name="street_name"
                        value={searchStreetName}
                        onChange={(e) => {
                          setSearchStreetName(e.target.value);
                        }}
                      />
                    ),
                    house_number_type: () => (
                      <SearchInputField
                        label={<>House Number</>}
                        name="house_number_parity"
                        onChange={(e) => {
                          setHouseNumberParity(e.target.value);
                        }}
                        type={"select"}
                        value={houseNumberParity}
                        options={houseNumberParityOptions}
                      />
                    ),
                  }}
                  customValues={customFilterValues}
                  onCustomChange={(key, value) =>
                    setCustomFilterValues((prev) => ({ ...prev, [key]: value }))
                  }
                />
                <SearchInputField
                  label={<>List Membership</>}
                  name="list_membership"
                  onChange={(e) => {
                    setSelectedMemberList(e.target.value);
                  }}
                  type={"select"}
                  value={selectedMemberList}
                  options={listMemberData}
                />

                <div className="flex justify-end items-center gap-x-2">
                  <button
                    type="submit"
                    className="py-3 px-6 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white "
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Multi-Street Search */}
      <div
        id="hs-search-address-modal"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-2xl  m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto max-h-[800px]">
            <div className="p-4 overflow-y-auto">
              <h4 className="pb-5 flex justify-center">
                Max. 3 address search allowed.
              </h4>
              <form
                className="w-full"
                onSubmit={(e) => {
                  e.preventDefault();
                  applyFilters();
                  document.querySelector("#hs-search-address-modal").click();
                }}
              >
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/3">
                    <label
                      className="block text-gray-500 font-bold text-center mb-1 md:mb-0 pr-4"
                      htmlFor="multi_street_city"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/3">
                    <AsyncSelect
                      loadOptions={loadCityOptions}
                      id="multi_street_city"
                      name="multi_street_city"
                      className="bg-gray-200 appearance-none border-none border-gray-200 rounded w-full  text-gray-700 leading-tight focus:outline-none z-[9999]"
                      classNames={{
                        menuList: () => "h-40",
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      defaultOptions={allCityOptions}
                      value={
                        searchCity
                          ? allCityOptions.find(
                            (option) => option.value === searchCity
                          )
                          : null
                      }
                      onChange={(selectedOption) => {
                        setSearchCity(
                          selectedOption ? selectedOption.value : ""
                        );
                      }}
                      isClearable
                    />
                  </div>
                </div>
                <TagInput
                  label={"Street Address"}
                  value={searchAddress}
                  setValue={setSearchAddress}
                />
                <div className="flex justify-center items-center gap-x-2 py-3 px-4 dark:border-gray-700">
                  <button
                    type="submit"
                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white "
                    data-hs-overlay="#hs-search-address-modal"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <MovedHouseholdModal
        household={movedTarget}
        open={!!movedTarget}
        onClose={closeMoved}
        onMoved={handleMoved}
      />
      <Dialog
        open={showAddHouseHold}
        onClose={handleCloseModal}
        className="relative z-50"
      >
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-canvas-primary/60 backdrop-blur-sm">
          <div
            className="absolute top-0 left-0 w-full h-screen z-10"
            onClick={handleCloseModal}
          />
          <div className="xl:max-w-6xl lg:max-w-5xl md:max-w-4xl max-w-4xl sm:w-full sm:mx-auto bg bg-white border rounded-xl pointer-events-auto max-h-[calc(100vh-3.5rem)] overflow-y-auto z-[99]">
            <div className="p-4 sm:p-6 md:p-8">
              <h2 className="font-bold uppercase flex justify-center mb-4">
                Add HouseHold Details
              </h2>

              {/* {isOpenFromMap && ( */}
              <div className="mt-8  mb-10 flex justify-end">
                <div
                  className={`hs-dropdown relative inline-flex z-50 ${showContact ? "open" : ""
                    } `}
                >
                  {houseHoldUserId !== "" && (
                    <button
                      id="hs-dropdown-hover-event"
                      className="hs-dropdown-toggle font-semibold flex items-center gap-5"
                      onClick={() => showAssociateContact(houseHoldUserId)}
                    // onClick={() => handleShowContact()}
                    >
                      ASSOCIATED CONTACTS <IoIosContacts className="w-7 h-7" />
                    </button>
                  )}

                  <AssociatedContact
                    isModel
                    fetchStats={fatchStats}
                    dataProperty={dataProperty}
                    isAssociateListLoading={isAssociateListLoading}
                    setShowAssociateList={setShowAssociateList}
                    showAssociateContact={showAssociateContact}
                    associatedContact={associatedContact[houseHoldUserId]}
                    hiddenFields={contactHiddenFields}
                    addContactModalData={{
                      l2Id,
                      mailing_city: addHHResponse?.mailing_city,
                      residence_state: addHHResponse?.residence_state,
                      residence_zip: addHHResponse?.residence_zip,
                    }}
                  />
                </div>
              </div>
              {/* )} */}
              <GoogleMapAutocomplete
                setSelected={setSelected}
                selected={selected}
              />
              <form onSubmit={(e) => handleHouseHoldSubmit(e)}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
                  <EditInputField
                    label="Street Number"
                    name="house_number"
                    value={streetNumberInput}
                    onChange={(e) => setStreetNumberInput(e.target.value)}
                  />
                  <EditInputField
                    label="Building Name"
                    name="building_name"
                    value={buildingNameInput}
                    onChange={(e) => setBuildingNameInput(e.target.value)}
                  />
                  <EditInputField
                    label="Apt Number"
                    name="apt_number"
                    value={aptNumberInput}
                    onChange={(e) => setAptNumberInput(e.target.value.replace(/\D/g, ""))}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                  {formField?.map((item, index) => {
                    return (
                      <EditInputField
                        key={index}
                        label={item?.label}
                        name={item?.name}
                        value={item?.value}
                        onChange={(e) =>
                          handleInputChange(item?.name, e.target.value)
                        }
                        type={item?.type}
                        options={item?.options}
                        required={item?.required}
                        loading={item?.loading}
                        disabled={item?.loading}
                      />
                    );
                  })}
                </div>
                <div className="flex items-center gap-5 mt-5">
                  <button
                    type="submit"
                    disabled={isSubmitLoading}
                    className="shadow bg-canvas-primary text-white font-bold py-2 px-6 rounded flex items-center gap-3"
                  >
                    {isSubmitLoading && <ButtonLoader />}
                    Save
                  </button>
                  <button
                    className="bg-gray-200 py-2 px-6 rounded"
                    onClick={(e) => handleCloseModal(e)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={showSaveContactsPrompt}
        onClose={handleDeclineSaveContacts}
        className="relative z-50"
      >
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-canvas-primary/60 backdrop-blur-sm">
          <div className="absolute top-0 left-0 w-full h-screen z-10" onClick={handleDeclineSaveContacts} />
          <div className="max-w-md sm:w-full mx-auto bg-white border rounded-xl pointer-events-auto z-[99] p-6">
            <h3 className="font-bold font-outfit mb-3">Save associated contacts too?</h3>
            <p className="text-sm font-outfit text-canvas-secondery mb-5">
              This fetches and caches the associated contacts for every saved household, so their contact list and details are available while offline.
            </p>
            <div className="flex justify-end gap-3">
              <button
                type="button"
                className="bg-gray-200 py-2 px-6 rounded text-sm font-semibold font-outfit"
                onClick={handleDeclineSaveContacts}
                disabled={isSavingContacts}
              >
                No
              </button>
              <button
                type="button"
                className="bg-canvas-primary text-white py-2 px-6 rounded text-sm font-semibold font-outfit inline-flex items-center gap-x-2 disabled:opacity-70"
                onClick={handleSaveContactsForOffline}
                disabled={isSavingContacts}
              >
                {isSavingContacts && <ButtonLoader />}
                {isSavingContacts ? "Saving..." : "Yes, save contacts"}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CanvassMap;
